// src/config/plotConfigs/timeSeriesConfig.js

export const timeSeriesConfig = {
  sections: [
    {
      fields: [
        {
          id: "geneType",
          label: "Gene Type",
          type: "radio",
          options: [
            { value: "all", label: "All" },
            { value: "coding", label: "Coding" },
            { value: "noncoding", label: "Non-coding" },
            { value: "custom", label: "Custom" },
          ],
          tooltip:
            "Analysis will be carried out on all genes (both coding and non-coding) regardless of which option is selected, this option only controls which genes can be displayed on the heatmap.",
          width: 4,
        },
        {
          id: "selectedSeqType",
          label: "Sequence Type",
          type: "radio",
          options: [
            { value: "TE", label: "TE" },
            { value: "ribo", label: "Ribo-Seq" },
            { value: "rna", label: "RNA-Seq" },
          ],
          tooltip:
            "If 'TE' (Translation efficiency) input sections for both Ribo-Seq and RNA-Seq will be shown below, if Ribo-seq or RNA-seq are selected only the corresponding input sections will be shown below.",
          width: 4,
        },
        {
          id: "geneNo",
          label: "Number of Genes Displayed",
          type: "text",
          placeholder: "e.g. 100",
          tooltip:
            "Determines the number of genes (sorted by adjusted p-value) that will be shown on the heatmap. This option is irrelevant if custom gene list is used, in which case all genes in the list will be shown regardless of what this value is set to.",
          width: 4,
        },
        {
          id: "customGeneList",
          label: "Custom Gene List",
          type: "textarea",
          placeholder: "Enter gene IDs (one per line or comma separated)",
          tooltip:
            "Optionally enter a list of gene names seperated by commas, only these genes will be shown in the heatmap. Transcript ID's not accepted.",
          width: 4,
          rows: 1,
          showIf: (settings) => settings.geneType === "custom",
        },

        {
          id: "riboRegion",
          label: "Ribo-Seq Region",
          type: "radio",
          options: [
            { value: "all", label: "All" },
            { value: "cds", label: "CDS" },
            { value: "fiveprime", label: "5' UTR" },
            { value: "threeprime", label: "3' UTR" },
          ],
          tooltip:
            "This determines which region the Ribo-Seq counts for a particular gene will be taken from. This only applies to coding genes, non-coding genes will always be set to 'All' which includes counts from non-coding transcripts.",
          width: 4,
        },
        {
          id: "rnaRegion",
          label: "RNA-Seq Region",
          type: "radio",
          options: [
            { value: "all", label: "All" },
            { value: "cds", label: "CDS" },
            { value: "fiveprime", label: "5' UTR" },
            { value: "threeprime", label: "3' UTR" },
          ],
          tooltip:
            "This determines which region the RNA-Seq counts for a particular transcript will be taken from. This only applies to coding genes, non-coding genes will always be set to 'All' which includes counts from non-coding transcripts",
          width: 4,
        },
        {
          id: "colMin",
          label: "Color Bar Minimum",
          type: "text",
          placeholder: "Auto",
          tooltip:
            "Optionally manually set the scale of the color bar, if left empty scaling will be automatic.",
          width: 4,
        },
        {
          id: "colMax",
          label: "Color Bar Maximum",
          type: "text",
          placeholder: "Auto",
          tooltip:
            "Optionally manually set the scale of the color bar, if left empty scaling will be automatic.",
          width: 4,
        },

        {
          id: "emailNotification",
          label: "Email notification",
          type: "checkbox",
          tooltip:
            "If checked an email notification will be sent to you once the job has completed. The email will contain a link to the results of this job.",
          width: 4,
        },
      ],
    },
  ],
};

export const timeSeriesDefaults = {
  geneType: "all",
  customGeneList: "",
  geneNo: "50",
  riboRegion: "cds",
  rnaRegion: "all",
  analysisType: "single_control",
  selectedSeqType: "TE",
  customControlName: "Control",
  customTreatmentName: "Treatment",
  colMin: "",
  colMax: "",
  emailNotification: false,
};

export const timeSeriesValidation = {
  geneType: { required: true, label: "Gene type" },
  custom: (value, allSettings) => {
    if (
      allSettings.geneType === "custom" &&
      !allSettings.customGeneList.trim()
    ) {
      return "Please provide custom gene list";
    }
    return null;
  },
};
